import { createSwitcherGroup } from '@leprecoins/effector';

export const createModalSwitcher = createSwitcherGroup();
